import React from 'react'
import { Wrapper } from './ShelfBackground.style'
import type { ShelfBackgroundProps } from './ShelfBackground.types'

const ShelfBackground: React.FC<ShelfBackgroundProps> = ({
  color,
  children,
  className
}) => {
  return (
    <Wrapper className={className} color={color}>
      {children}
    </Wrapper>
  )
}
export default ShelfBackground
